import React from "react"

import { Root } from "../Common/Root"
import Top from "../Top"

const TopPage = (props) => {
  return (
    <Root>
      <Top {...props} />
    </Root>
  )
}
export default TopPage
